var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teamrole__button",on:{"click":_vm.onClick}},[_c('div',{staticClass:"visual"},[_c('img',{attrs:{"src":_vm.visual}})]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d1531cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/minigames/teamrole/Button.vue
// module id = 9a/C
// module chunks = 0